
<div class="rowScreenColPhone">

	<div></div>

	<mat-spinner diameter=30 *ngIf="bLoading" />

	<button
		mat-raised-button
		color="primary"
		[disabled]="bLoading"
		(click)="showCreationDialog()"
	>
		Neue Rubrik
	</button>

</div>

<div>

	@if( !elements.length ) {
		@if( !bLoading ) {
			<div class="accNoElements">
				Keine Rubriken vorhanden
			</div>
		}
	}
	@else {

		<div class="accFilterAndAccordeon">

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
				class="accFilter"
			>

				<mat-label>Filter</mat-label>
				<input
					matInput
					placeholder="Beispiel: gruppe1"
					(keyup)="onFilterChanged($event)"
				>
				<mat-icon matSuffix>search</mat-icon>

			</mat-form-field>

			<div class="accAccordeon">

				@if( !filteredElements.length ) {

					<div class="accNoElements">
						Keine Daten entspricht dem Filter
					</div>

				}	
				@else {

					<div
						class="accHeaders"
						[class.accSortIconDesc]="!sortingAsc"
					>

						<div
							class="accCell"
							[class.accActiveSorting]="sortingField == 'name'"
							(click)="sortColumn('name')"
							title="Nach Name sortieren"
						>
							<div class="accHeader">
								<span>Name</span>
								<mat-icon class="accSortIcon">
									{{ sortingField == 'name' ? 'arrow_downward' : 'swap_vert' }}
								</mat-icon>
							</div>
						</div>

					</div>
						
					<div class="accScrollPanel">

						@for( element of filteredElements; track element.id ) {

							<div
								class="accRow"
								(click)="clickOnRow( element.id )"
								[class.accRowActive]="expandedElementId == element.id"
								[id]="'elementRow_' + element.id"
							>
								<div class="accCell">
									{{ element.name }}
								</div>
							</div>

							@if( expandedElementId == element.id ) {

								<div
									class="accDetail"
									[@accordeonMe]
								>
									<app-rubric-editor
										[group]="element"
										(deleted)="onRubricDeleted(element)"
									/>
								</div>

							}

						}

					</div>

				}

			</div>

		</div>

	}

</div>


